'use client'
import Image from 'next/image'
import { useState } from 'react'
import { PrismicNextImage } from '@prismicio/next'
import { PrismicLink, PrismicText } from '@prismicio/react'

type DataObject = Record<string, any>
type ItemObject = Record<string, any>

const TrainingPreviewComponent = ({ data }: { data: DataObject }) => {
  const [currentLesson, setCurrentLesson] = useState(0)
  return (
    <section className="relative z-10 bg-primary-ink-100 py-[100px]">
      <div className="compliance-platform-bg-top">
        <Image
          src="/images/compliance-bg-top.svg"
          alt="compliance-bg-top"
          width={0}
          height={0}
          sizes="100vw"
          style={{ width: '100%', height: 'auto' }}
        />
      </div>
      <div className="container">
        <div className="mb-16 text-center">
          <h2 className="mx-auto mb-4 max-w-[900px] text-white">
            <PrismicText field={data.primary.preview_title} />
          </h2>
          <p className="text-white">
            <PrismicText field={data.primary.preview_description} />
          </p>
        </div>
        <div className="flex flex-wrap gap-8 md:flex-nowrap">
          <ul className="w-full md:w-2/4">
            {data.items.map((lesson: ItemObject, index: number) => (
              <li
                key={index}
                role="button"
                tabIndex={0}
                onClick={() => setCurrentLesson(index)}
                className={currentLesson === index ? 'hippa-training-list active' : 'hippa-training-list'}>
                <div className="mb-3 flex items-center">
                  <div className="mr-4 flex h-12 w-12 items-center justify-center rounded-full bg-white">
                    <PrismicNextImage field={lesson.lesson_icon} width={25} height={25} fallbackAlt="" />
                  </div>
                  <span className="text-white opacity-70">{`Lesson #${index + 1}`}</span>
                </div>
                <div className="content">
                  <h3 className="text-2xl text-white">
                    <PrismicText field={lesson.lesson_title} />
                  </h3>
                  <p className="hidden text-white opacity-70">
                    <PrismicText field={lesson.lesson_description} />
                  </p>
                </div>
              </li>
            ))}
          </ul>
          <div className="sticky top-24 h-fit w-full md:w-2/4">
            <PrismicNextImage field={data.items[currentLesson].lesson_thumbnail} className="mb-8 rounded-md" fallbackAlt="" />
            <PrismicLink
              href="https://app.secureframe.com/hipaa/training"
              target="_blank"
              aria-label="Opens in a new tab"
              className="btn btn-default btn-secondary btn-interaction">
              Get Started
              <Image
                src="/images/angle-right-black.svg"
                width={20}
                height={16}
                alt=""
                className="not-sr-only"
                aria-hidden="true"
              />
            </PrismicLink>
          </div>
        </div>
      </div>
      <div className="compliance-platform-bg-bottom">
        <Image
          src="/images/compliance-bg-bottom.svg"
          alt="compliance-bg-bottom"
          width={0}
          height={0}
          sizes="100vw"
          style={{ width: '100%', height: 'auto' }}
        />
      </div>
    </section>
  )
}

export default TrainingPreviewComponent
